import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

interface QuestionStat {
  label: string;
  views: number;
  answers: number;
  dropOff: number;
}

interface QuestionAnalyticsProps {
  questions: QuestionStat[];
}

export function QuestionAnalytics({ questions }: QuestionAnalyticsProps) {
  if (questions.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Question Performance</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">No question data available yet.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Question Performance</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="grid grid-cols-[1fr_80px_80px_100px] gap-2 text-xs font-medium text-muted-foreground px-3 pb-1 border-b border-border">
            <span>Question</span>
            <span className="text-center">Views</span>
            <span className="text-center">Answers</span>
            <span className="text-center">Drop-off</span>
          </div>
          {questions.map((q, i) => {
            const isHighDropOff = q.dropOff > 40;
            return (
              <div
                key={i}
                className={`grid grid-cols-[1fr_80px_80px_100px] gap-2 items-center text-sm px-3 py-2 rounded-md transition-colors ${
                  isHighDropOff
                    ? 'bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-900/40'
                    : 'hover:bg-muted/50'
                }`}
              >
                <span className="truncate font-medium text-foreground">{q.label}</span>
                <span className="text-center text-muted-foreground">{q.views}</span>
                <span className="text-center text-muted-foreground">{q.answers}</span>
                <div className="flex items-center justify-center gap-1">
                  {isHighDropOff && <AlertTriangle className="h-3 w-3 text-red-500 shrink-0" />}
                  <span className={`font-medium ${isHighDropOff ? 'text-red-500' : 'text-foreground'}`}>
                    {q.dropOff}%
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
